<div class="inner-content" padding>
  <ion-grid>
    <ion-row padding-top="" padding-bottom="">
      <ion-col size="12" text-center class="order-title flex-content-center">
        <ion-icon name="document" color="dark"></ion-icon>
        <ion-text font-bold="" color="dark">{{
          orderDetails.formattedId
        }}</ion-text>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12" text-center="" class="item-name flex-content-center">
        <ion-img [src]="orderDetails?.orderItems[0]?.item?.icon"></ion-img>
        <ion-text font-bold="" color="dark">
          {{ orderDetails?.orderItems[0]?.item?.name }}</ion-text
        >
      </ion-col>
      <ion-col size="12" text-center class="enter-qty" margin-top="">
        <ion-text font-bold="" color="dark">ENTER QUANTITY</ion-text>
      </ion-col>
      <ion-col size="12" class="enter-qty-text" text-center="">
        <ion-text color="medium" text-regular="">
          That you are dispatching to the buyer. Quantity should be the same as
          in weigh bridge bill
        </ion-text>
      </ion-col>
      <ion-col
        size="12"
        text-center
        margin-top=""
        margin-bottom=""
        class="qty-input"
      >
        <ion-item
          lines="none"
          [ngClass]="{
            'item-error':
              (orderDetails.orderItems[0].verifyQty <= 0 &&
                orderDetails.orderItems[0].verifyQty != null) ||
              isFloat(orderDetails.orderItems[0].verifyQty)
          }"
        >
          <ion-input
            #qtyInput
            no-padding=""
            no-margin
            font-bold
            [(ngModel)]="orderDetails.orderItems[0].verifyQty"
            maxlength="10"
            clear-on-edit
            type="number"
          ></ion-input>
          <ion-label no-margin slot="end" text-medium color="medium">{{
            orderDetails?.orderItems[0]?.item?.unitType
          }}</ion-label>
          <div no-margin slot="end" class="plus-minus-btn">
            <ion-icon
              name="arrow-dropup"
              color="medium"
              (click)="
                orderDetails.orderItems[0].verifyQty =
                  orderDetails.orderItems[0].verifyQty + 1
              "
            ></ion-icon>
            <ion-icon
              name="arrow-dropdown"
              color="medium"
              (click)="
                orderDetails.orderItems[0].verifyQty > 0
                  ? (orderDetails.orderItems[0].verifyQty =
                      orderDetails.orderItems[0].verifyQty - 1)
                  : (orderDetails.orderItems[0].verifyQty = 0)
              "
            >
            </ion-icon>
          </div>
        </ion-item>

        <!--<ion-input [(ngModel)]="orderDetails.orderItems[0].verifyQty" clear-on-edit type="number">
                    <ion-text text-regular text-capitalize>{{orderDetails?.orderItems[0]?.item?.unitType | lowercase}}</ion-text>
                    <div no-margin slot="end" class="plus-minus-btn">
                        <ion-icon name="arrow-dropup" color="medium" (click)="qty = qty + 1 "></ion-icon>
                        <ion-icon name="arrow-dropdown" color="medium" (click)="qty > 0 ? qty = qty - 1 : qty = 0"></ion-icon>
                    </div>
                </ion-input>-->
      </ion-col>
      <ion-col size="12" text-center="" class="upload-title">
        <ion-text font-bold="" color="dark">Upload Weigh-bridge</ion-text>
      </ion-col>
      <ion-col size="12" text-center="" class="upload-sub-title">
        <ion-text color="medium"
          >Before & after loading both bills required for weigh bridge</ion-text
        >
      </ion-col>
      <ion-col size="12" class="img-list">
        <!--
                [showDelete]="(order?.status === 'CREATED')"
                [showCapture]="(order?.status === 'CREATED')"-->
        <rcyl-img-list
          [docList]="sellerWeighBridgeImgs"
          (onCapture)="weighBridgeImgCapture()"
          [docType]="orderDocumentTypes.SELLER_WEIGH_BRIDGE"
          [downloadDocumentCallback]="deleteDocumentCallback"
          [deleteDocumentCallback]="deleteDocumentCallback"
          [showDelete]="true"
          [showCapture]="true"
        ></rcyl-img-list>
      </ion-col>
      <ion-col size="12" text-center="" class="upload-note">
        <ion-text color="medium">
          <i>
            <span font-bold="">Note •</span> You can dispatch order only after
            uploading the weigh-bridge bills
          </i>
        </ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
<ion-footer no-border>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-button
          [disabled]="!this.sellerWeighBridgeImgs.length"
          color="primary"
          size="large"
          expand="block"
          (click)="dispatchedClicked()"
        >
          Mark as dispatched
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
